module.exports = __webpack_public_path__ + "assets/img/hero.addda1df.jpg";